import { render, staticRenderFns } from "./Pasosdelproceso.vue?vue&type=template&id=37671e1a&scoped=true&"
import script from "./Pasosdelproceso.vue?vue&type=script&lang=js&"
export * from "./Pasosdelproceso.vue?vue&type=script&lang=js&"
import style0 from "./Pasosdelproceso.vue?vue&type=style&index=0&id=37671e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37671e1a",
  null
  
)

export default component.exports